import React, { createContext, useEffect } from "react";
import socketService from "../../socket/socket";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { getUserByContact } from "../../services/user";
import {
  setUserBranches,
  setUserFleets,
} from "../../redux/slices/user/userSlice";
import { updateOperationsAllCount } from "../../redux/slices/sidebareBadges/api";
import { getCustomerOrderQuickData } from "../../redux/slices/customerBooking/api";
import { setCustomerDocketLocation } from "../../redux/slices/liveLocation/liveLocationSlice";
import { updateChatData } from "../../redux/slices/customerChat/customerChatSlice";
import { acceptIntracityBooking } from "../../redux/slices/customerBooking/customerBookingSlice";
import { updateCCAvenueTxnsStutus } from "../../redux/slices/PaymentGateWay/paymentGateWaySlice";
import { UPDATE_CCAVENUE_TXNS_STATUS } from "../../constants/paymentGateWay";

export type SocketContextType = {
  socket: typeof socketService;
};

type SocketProviderProps = {
  children: React.ReactNode;
  // token: string | null; // Pass authentication token
};

export const SocketContext = createContext<SocketContextType | undefined>(
  undefined
);

export const SocketProvider: React.FC<SocketProviderProps> = ({
  children,
  // token,
}) => {
  const socket = socketService;
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const role = sessionStorage.getItem("role");
  const token =
    role == "customer"
      ? localStorage.getItem("kabra:customertoken")
      : sessionStorage.getItem("kabra:token");

  useEffect(() => {
    if (token && user?.accessToken) {
      try {
        // Initialize the socket connection with the token
        socketService.initializeConnection(token);
        console.log("Socket connection initialized.");
      } catch (error) {
        console.error("Error initializing socket connection:", error);
      }
    }

    return () => {
      try {
        socketService.disconnect();
        console.log("Socket connection disconnected.");
      } catch (error) {
        console.error("Error during socket disconnection:", error);
      }
    };
  }, [token,socketService]);


  if (token) {
    const id = setInterval(() => {
      // console.log("refresh :",token)
      socket.emit("refresh", token);
    }, 5000);
    // socket.on("connect", () => {
    //   socket.emit("action", {
    //     type: REGISTER_SOCKET,
    //     data: { token: token},
    //   });
    // });
    socket.on("logout", () => {
      clearInterval(id);
      window.location.reload();
    });
    socket.on("reconnect", () => {
      // socket.emit("action", {
      //   type: REAUTH_SOCKET,
      //   data: { token: token },
      // });
      if (user?.opBranch?._id) {
        const { _id, branchName } = user?.opBranch;
        socket.emit("branchLogin", { opBranch: { _id, branchName } });
      }
    });
  }
  socket.on("setFilteredBranches", async (data: any) => {
    // let company =
    //   store &&
    //   store.getState() &&
    //   (store.getState() as any)?.user &&
    //   (store.getState() as any)?.user?.company &&
    //   (store.getState() as any)?.user?.company?._id;
    let isAuthenticated = user?.socketLockAcquired;

    if (isAuthenticated) {
      try {
        // store.dispatch({
        //   type: "SET_FILTERED_BRANCHES",
        //   payload: {
        //     data: await filterBookBranches({ company } as any),
        //     query: company,
        //   },
        // });
        // store.dispatch({
        //   type: "SET_BRANCHES",
        //   payload: await getAllBranchesByCompany(company as any),
        // });
        if (
          user &&
          user.branches &&
          user.branches.length > 0 &&
          user.branches.find((x: any) => x._id === data.updatedId)
        ) {
          let response = await getUserByContact(user.contact as any);
          dispatch(setUserBranches(response.branches));
        }
        if (user && user.opBranch && user.opBranch._id === data.updatedId) {
          const payload = {
            user: user?.uid,
            sub: "B",
            entity: data.updatedId,
            company: user?.company?._id,
          };
          socket.emit("branchLogin", payload);
          dispatch({
            type: "SEL_OP_BRANCH",
            payload: { value: data.updatedId },
            isSocketAction: true,
          });

          dispatch(updateOperationsAllCount() as any);
        }
      } catch (err: any) {}
    }
  });

  socket.on("setUpdatedBranch", async (data: any) => {
    try {
      if (
        user &&
        user.branches &&
        user.branches.length > 0 &&
        user.branches.find((x: any) => x._id === data.updatedId)
      ) {
        let response = await getUserByContact(user.contact as any);

        dispatch(setUserBranches(response.branches));
      }

      if (user && user.opBranch && user.opBranch._id === data.updatedId) {
        const payload = {
          user: user?.uid,
          sub: "B",
          entity: data.updatedId,
          company: user?.company._id,
        };
        socket.emit("branchLogin", payload);
        dispatch({
          type: "SEL_OP_BRANCH",
          payload: { value: data.updatedId },
          isSocketAction: true,
        });

        dispatch(updateOperationsAllCount() as any);
      }
    } catch (err: any) {
      console.log(err);
    }
  });

  socket.on("setAssignedBranches", async () => {
    try {
      let response = await getUserByContact(user?.contact as any);

      dispatch(setUserBranches(response.branches));
    } catch (err: any) {
      console.log(err);
    }
  });

  socket.on("setAssignedFleets", async () => {
    try {
      let response = await getUserByContact(user?.contact as any);
      await dispatch(setUserFleets(response.fleets));
    } catch (err: any) {
      console.log(err);
    }
  });

  socket.on("newCustomerBookingNotification", (data: any) => {
    dispatch(getCustomerOrderQuickData(data) as any);
  });

  socket.on("receiveLiveDocketTracking", (data: any) => {
    dispatch(setCustomerDocketLocation(data) as any);
  });

  socket.on("chatMessageUpdated", (data: any) => {
    dispatch(updateChatData(data));
  });
  socket.on("action", (data: any) => {
    if (data.type == "ACCEPT_INTRACITY_BOOKING") {
      console.log("ACCEPT_INTRACITY_BOOKING : ", data);
      dispatch(acceptIntracityBooking(data.payload));
    }
  });
  socket.on(UPDATE_CCAVENUE_TXNS_STATUS, (data: any) => {
    dispatch(updateCCAvenueTxnsStutus(data.payload));
  });

  return (
    <SocketContext.Provider value={{ socket: socketService }}>
      {children}
    </SocketContext.Provider>
  );
};
